import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu'
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import hamburger from './image/hamburger.png';
import trust from './image/trust.png';
import ambulance from './image/ambulance.png';
import profile from './image/man-user.png';
import help from './image/question.png';
import home from './image/home.png';
import logo from './image/NHS 10mm - RGB Blue on white.jpg';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 navbar-background navbarheight" light>
                    <Container>
                        <Menu customBurgerIcon={<img src={hamburger} className="menuButton" />}>
                            <span className="bm-menu-profile"><img src={profile} className="image-cropper" /></span>
                            <a id="Home" className="menu-item" href="/" className="bm-menu-link"><img src={home} className="bm-menu-icons" /><span className="bm_span_spacing">Home</span></a>
                            <a id="SITREP" className="menu-item" href="/SITREP" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">SITREP</span></a>
                            <a id="AmbulanceDaily" className="menu-item" href="/ambulancestatus" className="bm-menu-link"><img src={ambulance} className="bm-menu-icons" /><span className="bm_span_spacing">Ambulance Daily</span></a>
                            <a id="Acute" className="menu-item" href="/acutestatus" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">Acute Near Realtime</span></a>
                            <a id="AmbulanceReal" className="menu-item" href="/ambulancerealstatus" className="bm-menu-link"><img src={ambulance} className="bm-menu-icons" /><span className="bm_span_spacing">Ambulance Near Realtime</span></a>
                            <a id="JointReporting" className="menu-item" href="/jointreporting" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">Joint Reporting</span></a>
                            <a id="CovidReporting" className="menu-item" href="/covidreporting" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">Covid Reporting</span></a>
                            <a id="MHECDS" className="menu-item" href="/mhecds" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">MH ECDS</span></a>
                            <a id="MHCRISIS" className="menu-item" href="/mhcrisis" className="bm-menu-link"><img src={trust} className="bm-menu-icons" /><span className="bm_span_spacing">MH CRISIS</span></a>
                            <a id="Help" className="menu-item" href="/help" className="bm-menu-link"><img src={help} className="bm-menu-icons" /><span className="bm_span_spacing">Help</span></a>
                        </Menu>
                        <NavbarBrand tag={Link} to="/" className="brand text-white">
                            <img src={logo} width="55" height="27" alt="" /><span className="bm_span_spacing">NHS England and NHS Improvement Service Status</span>
                        </NavbarBrand>
                        <a id="Help" className="menu-item" href="/help" className="bm-menu-link"><img src={help} className="bm-menu-icons helpMenu" /></a>
                    </Container>
                </Navbar>
            </header>
                );
            }
        }



// WEBPACK FOOTER //
// ./src/components/NavMenu.js